import React, { useEffect, useState } from 'react';
import * as Routes from '@/modules/routes';
import Axios from 'axios';
import Spinner from '@/components/common/Spinner';
import GlossaryCard from './GlossaryCard';
import VocabSelectModal from './VocabSelectModal';
import { GlossaryTermModel, SlideObject } from '../../../types';

interface SlideObjectVocabProps {
  interactable: boolean;
  modalManager: ModalManager;
  slideObject: SlideObject;
}

const SlideObjectVocab = ({ interactable, modalManager, slideObject }: SlideObjectVocabProps) => {
  const [loading, setLoading] = useState(true);
  const [linkedVocab, setLinkedVocab] = useState<GlossaryTermModel[]>([]);

  useEffect(() => {
    Axios.get(Routes.plato_api_get_glossary_term_models_slide_objects_path(), { params: { id: slideObject.id } })
      .then((res) => {
        setLinkedVocab(res.data.data);
        setLoading(false);
      });
  }, []);

  if (loading) return <Spinner />;

  return (
    <>
      {linkedVocab.length > 0 && (
        <GlossaryCard glossaryTerm={linkedVocab[0].glossary_term} />
      )}
      {interactable && (
        <VocabSelectModal
          linkedVocab={linkedVocab}
          modalManager={modalManager}
          setLinkedVocab={setLinkedVocab}
          slideObject={slideObject}
        />
      )}
    </>
  );
};

export default SlideObjectVocab;
